var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "evaluation-card",
      attrs: { animation: "slide", open: _vm.isOpen, "data-cy": "params-data" },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function ({ open }) {
            return [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { role: "button", "aria-expanded": open.toString() },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _vm._v(" Parámetros usados "),
                  ]),
                  _c(
                    "a",
                    { staticClass: "card-header-icon" },
                    [
                      _c("b-icon", {
                        attrs: { icon: open ? "minus" : "plus" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "card-block p-0 pb-1" }, [
        _c(
          "div",
          { staticClass: "subcard" },
          [
            _c(
              "b-field",
              { attrs: { label: "Segmento", horizontal: "" } },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      placeholder: "Selecciona un segmento",
                      expanded: "",
                    },
                    model: {
                      value: _vm.simulation.offerParams.segment,
                      callback: function ($$v) {
                        _vm.$set(_vm.simulation.offerParams, "segment", $$v)
                      },
                      expression: "simulation.offerParams.segment",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "SUBSIDY" } }, [
                      _vm._v("Subsidio"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Subsegmento", horizontal: "" } },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      placeholder: "Selecciona un subsegmento",
                      expanded: "",
                    },
                    model: {
                      value: _vm.simulation.offerParams.subSegment,
                      callback: function ($$v) {
                        _vm.$set(_vm.simulation.offerParams, "subSegment", $$v)
                      },
                      expression: "simulation.offerParams.subSegment",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "SUBSIDY_1_1" } }, [
                      _vm._v("1.1"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_2_1" } }, [
                      _vm._v("2.1"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_2_2B" } }, [
                      _vm._v("2.2B"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_1_1B" } }, [
                      _vm._v("1.1B"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_2_1" } }, [
                      _vm._v("2.1B"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_1_1" } }, [
                      _vm._v("1.1B"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_1_2" } }, [
                      _vm._v("1.2B"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_1_2B" } }, [
                      _vm._v("1.2B"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_2_1B" } }, [
                      _vm._v("2.1B"),
                    ]),
                    _c("option", { attrs: { value: "SUBSIDY_2_2" } }, [
                      _vm._v("2.2B"),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header" },
            [
              _c("p", { staticClass: "header-title" }, [
                _vm._v("Restricciones financieras"),
              ]),
              _c("b-button", {
                staticClass: "header-icon",
                attrs: {
                  size: "is-small",
                  "icon-left": _vm.financialRestrictionsOpen
                    ? "angle-up"
                    : "angle-down",
                },
                on: { click: _vm.toggleFinancialRestrictions },
              }),
            ],
            1
          ),
          _vm.financialRestrictionsOpen
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Máxima carga financiera",
                      placeholder: "Ingresa valor",
                      prefix: "%",
                      size: "is-small",
                      "prefix-position": "left",
                      value: _vm.formatPercentage(
                        _vm.simulation.offerParams.maximumBackendRatio
                      ),
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Máximo dividendo-renta",
                      placeholder: "Ingresa valor",
                      prefix: "%",
                      size: "is-small",
                      "prefix-position": "left",
                      value: _vm.formatPercentage(
                        _vm.simulation.offerParams.maximumFrontendRatio
                      ),
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Máximo deuda-garantía",
                      placeholder: "Ingresa valor",
                      prefix: "%",
                      size: "is-small",
                      "prefix-position": "left",
                      value: _vm.formatPercentage(
                        _vm.simulation.offerParams.maximumCreditLTV
                      ),
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Pie mínimo",
                      placeholder: "Ingresa valor",
                      prefix: "%",
                      size: "is-small",
                      "prefix-position": "left",
                      value: _vm.formatPercentage(
                        1 - _vm.simulation.offerParams.maximumPropertyLTV
                      ),
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Oferta máxima",
                      placeholder: "Ingresa valor",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerParams.creditMaxAmount,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerParams,
                          "creditMaxAmount",
                          $$v
                        )
                      },
                      expression: "simulation.offerParams.creditMaxAmount",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Oferta mínima",
                      placeholder: "Ingresa valor",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerParams.creditMinAmount,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerParams,
                          "creditMinAmount",
                          $$v
                        )
                      },
                      expression: "simulation.offerParams.creditMinAmount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header" },
            [
              _c("p", { staticClass: "header-title" }, [
                _vm._v("Estructura del dividendo"),
              ]),
              _c("b-button", {
                staticClass: "header-icon",
                attrs: {
                  size: "is-small",
                  "icon-left": _vm.dividendStructureOpen
                    ? "angle-up"
                    : "angle-down",
                },
                on: { click: _vm.toggleDividendStructure },
              }),
            ],
            1
          ),
          _vm.dividendStructureOpen
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: { label: "Forma de amortización", horizontal: "" },
                    },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: {
                            disabled: _vm.readOnly,
                            size: "is-small",
                            placeholder: "Selecciona una forma",
                            expanded: "",
                          },
                          model: {
                            value:
                              _vm.simulation.offerParams.amortizationMethod,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.simulation.offerParams,
                                "amortizationMethod",
                                $$v
                              )
                            },
                            expression:
                              "simulation.offerParams.amortizationMethod",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "FRENCH" } }, [
                            _vm._v("Francesa"),
                          ]),
                          _c("option", { attrs: { value: "GERMANY" } }, [
                            _vm._v("Alemana"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Tasa de interés anual",
                      placeholder: "Ingresa tasa",
                      prefix: "%",
                      size: "is-small",
                      value: _vm.formatPercentage(
                        _vm.simulation.offerParams.annualInterestRate
                      ),
                      "prefix-position": "left",
                    },
                  }),
                  _c(
                    "b-field",
                    { attrs: { label: "Tipo de interés", horizontal: "" } },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: {
                            disabled: _vm.readOnly,
                            size: "is-small",
                            placeholder: "Selecciona un tipo",
                            expanded: "",
                          },
                          model: {
                            value: _vm.simulation.offerParams.interestType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.simulation.offerParams,
                                "interestType",
                                $$v
                              )
                            },
                            expression: "simulation.offerParams.interestType",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "COMPOUND" } }, [
                            _vm._v("Compuesto"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "subcard" },
                    [
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Amortización pospuesta",
                            horizontal: "",
                          },
                        },
                        [
                          _c("b-switch", {
                            attrs: { size: "is-small", disabled: _vm.readOnly },
                            model: {
                              value:
                                _vm.simulation.offerParams
                                  .isCreditInsuranceAccelerated,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.simulation.offerParams,
                                  "isCreditInsuranceAccelerated",
                                  $$v
                                )
                              },
                              expression:
                                "simulation.offerParams.isCreditInsuranceAccelerated",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.simulation.offerParams.isCreditInsuranceAccelerated
                        ? _c(
                            "div",
                            { staticClass: "fields-horizontal" },
                            [
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: "Distribución",
                                    horizontal: "",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "inner" }, [
                                    _c(
                                      "div",
                                      { staticClass: "inner-col" },
                                      [
                                        _c("BInputExpanded", {
                                          attrs: {
                                            disabled: _vm.readOnly,
                                            label: "Desde",
                                            placeholder: "1",
                                            prefix: "cuota",
                                            size: "is-small",
                                            "prefix-position": "left",
                                          },
                                          model: {
                                            value: _vm.distributionStart,
                                            callback: function ($$v) {
                                              _vm.distributionStart = $$v
                                            },
                                            expression: "distributionStart",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "inner-col" },
                                      [
                                        _c("BInputExpanded", {
                                          attrs: {
                                            disabled: _vm.readOnly,
                                            label: "Hasta",
                                            placeholder: "5",
                                            prefix: "cuota",
                                            size: "is-small",
                                            "prefix-position": "left",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "subcard" },
                    [
                      _c(
                        "b-field",
                        {
                          attrs: { label: "Interés pospuesto", horizontal: "" },
                        },
                        [
                          _c("b-switch", {
                            attrs: { size: "is-small", disabled: _vm.readOnly },
                            model: {
                              value: _vm.graceMonthsInterestMethod,
                              callback: function ($$v) {
                                _vm.graceMonthsInterestMethod = $$v
                              },
                              expression: "graceMonthsInterestMethod",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.graceMonthsInterestMethod
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: "Distribución",
                                    horizontal: "",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "inner" }, [
                                    _c(
                                      "div",
                                      { staticClass: "inner-col" },
                                      [
                                        _c("BInputExpanded", {
                                          attrs: {
                                            disabled: _vm.readOnly,
                                            label: "Desde",
                                            placeholder: "1",
                                            prefix: "cuota",
                                            size: "is-small",
                                            "prefix-position": "left",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "inner-col" },
                                      [
                                        _c("BInputExpanded", {
                                          attrs: {
                                            disabled: _vm.readOnly,
                                            label: "Hasta",
                                            placeholder: "5",
                                            prefix: "cuota",
                                            size: "is-small",
                                            "prefix-position": "left",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header header-switch" },
            [
              _c(
                "b-field",
                {
                  attrs: { label: "¿Tiene seguro de crédito?", horizontal: "" },
                },
                [
                  _c("b-switch", {
                    attrs: {
                      value:
                        _vm.simulation.offerParams.creditInsuranceRate !== 0,
                      size: "is-small",
                      disabled: _vm.readOnly,
                    },
                    model: {
                      value: _vm.hasCreditInsurance,
                      callback: function ($$v) {
                        _vm.hasCreditInsurance = $$v
                      },
                      expression: "hasCreditInsurance",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.creditInsuranceStructureOpen || _vm.hasCreditInsurance
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  (
                    _vm.readOnly
                      ? _vm.simulation.offerParams.creditInsuranceRate !== 0
                      : _vm.hasCreditInsurance
                  )
                    ? _c(
                        "div",
                        [
                          _c("BInputExpanded", {
                            attrs: {
                              disabled: _vm.readOnly,
                              label: "Tasa bruta",
                              placeholder: "Ingresa valor",
                              prefix: "%",
                              size: "is-small",
                              value: _vm.formatPercentage(_vm.grossRate),
                              "prefix-position": "left",
                            },
                          }),
                          _c("BInputExpanded", {
                            attrs: {
                              disabled: _vm.readOnly,
                              label: "Tasa líquida",
                              placeholder: "Ingresa valor",
                              prefix: "%",
                              size: "is-small",
                              value: _vm.formatPercentage(
                                _vm.simulation.offerParams.creditInsuranceRate
                              ),
                              "prefix-position": "left",
                            },
                          }),
                          _c("BInputExpanded", {
                            attrs: {
                              disabled: _vm.readOnly,
                              label: "Tasa de impuesto",
                              placeholder: "Ingresa valor",
                              prefix: "%",
                              size: "is-small",
                              value: _vm.formatPercentage(
                                _vm.simulation.offerParams.taxRate
                              ),
                              "prefix-position": "left",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "subcard" },
                            [
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: "¿Se incluye en el crédito?",
                                    horizontal: "",
                                  },
                                },
                                [
                                  _c("b-switch", {
                                    attrs: {
                                      value:
                                        _vm.simulation.generalParams
                                          .insuranceableValue !== 0,
                                      size: "is-small",
                                      disabled: _vm.readOnly,
                                    },
                                    model: {
                                      value: _vm.isIncludedInCredit,
                                      callback: function ($$v) {
                                        _vm.isIncludedInCredit = $$v
                                      },
                                      expression: "isIncludedInCredit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              (
                                _vm.readOnly
                                  ? _vm.simulation.generalParams
                                      .insuranceableValue !== 0
                                  : _vm.isIncludedInCredit
                              )
                                ? _c(
                                    "div",
                                    [
                                      _c("BInputExpanded", {
                                        attrs: {
                                          disabled: _vm.readOnly,
                                          label: "Cantidad de cuotas",
                                          placeholder: "Ingresa número",
                                          prefix: "cuotas",
                                          size: "is-small",
                                          "prefix-position": "left",
                                        },
                                        model: {
                                          value:
                                            _vm.simulation.offerParams
                                              .creditInsuranceNumberOfMonths,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.simulation.offerParams,
                                              "creditInsuranceNumberOfMonths",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "simulation.offerParams.creditInsuranceNumberOfMonths",
                                        },
                                      }),
                                      _c(
                                        "b-field",
                                        {
                                          attrs: {
                                            label: "Distribución",
                                            horizontal: "",
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "inner" }, [
                                            _c(
                                              "div",
                                              { staticClass: "inner-col" },
                                              [
                                                _c("BInputExpanded", {
                                                  attrs: {
                                                    disabled: _vm.readOnly,
                                                    label: "desde",
                                                    placeholder: "1",
                                                    prefix: "cuota",
                                                    size: "is-small",
                                                    "prefix-position": "left",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.distributionStartCredit,
                                                    callback: function ($$v) {
                                                      _vm.distributionStartCredit =
                                                        $$v
                                                    },
                                                    expression:
                                                      "distributionStartCredit",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "inner-col" },
                                              [
                                                _c("BInputExpanded", {
                                                  attrs: {
                                                    disabled: _vm.readOnly,
                                                    label: "hasta",
                                                    placeholder: "5",
                                                    prefix: "cuota",
                                                    size: "is-small",
                                                    "prefix-position": "left",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "subcard" },
                                        [
                                          _c(
                                            "b-field",
                                            {
                                              attrs: {
                                                label: "¿Se acelera el pago?",
                                                horizontal: "",
                                              },
                                            },
                                            [
                                              _c("b-switch", {
                                                attrs: {
                                                  value:
                                                    _vm.simulation.offerParams
                                                      .isCreditInsuranceAccelerated,
                                                  size: "is-small",
                                                  disabled: _vm.readOnly,
                                                },
                                                model: {
                                                  value:
                                                    _vm.isPaymentAccelerated,
                                                  callback: function ($$v) {
                                                    _vm.isPaymentAccelerated =
                                                      $$v
                                                  },
                                                  expression:
                                                    "isPaymentAccelerated",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          (
                                            _vm.readOnly
                                              ? _vm.simulation.offerParams
                                                  .isCreditInsuranceAccelerated
                                              : _vm.isPaymentAccelerated
                                          )
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "b-field",
                                                    {
                                                      attrs: {
                                                        label: "Distribución",
                                                        horizontal: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "inner",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "inner-col",
                                                            },
                                                            [
                                                              _c(
                                                                "BInputExpanded",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnly,
                                                                    label:
                                                                      "desde",
                                                                    placeholder:
                                                                      "1",
                                                                    prefix:
                                                                      "cuota",
                                                                    size: "is-small",
                                                                    "prefix-position":
                                                                      "left",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.distributionStartCredit,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.distributionStartCredit =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "distributionStartCredit",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "inner-col",
                                                            },
                                                            [
                                                              _c(
                                                                "BInputExpanded",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnly,
                                                                    label:
                                                                      "hasta",
                                                                    placeholder:
                                                                      "5",
                                                                    prefix:
                                                                      "cuota",
                                                                    size: "is-small",
                                                                    "prefix-position":
                                                                      "left",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "b-field",
                                                    {
                                                      attrs: {
                                                        label: "Tipo de deuda",
                                                        horizontal: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "b-select",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.readOnly,
                                                            size: "is-small",
                                                            placeholder:
                                                              "Selecciona un tipo de deuda",
                                                            expanded: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.simulation
                                                                .offerParams
                                                                .creditInsuranceFeeTermDefinition,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.simulation
                                                                  .offerParams,
                                                                "creditInsuranceFeeTermDefinition",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "simulation.offerParams.creditInsuranceFeeTermDefinition",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "SHORT",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Corto plazo"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "LONG",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Largo plazo"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header" },
            [
              _c("p", { staticClass: "header-title" }, [
                _vm._v("Seguros obligatorios"),
              ]),
              _c("b-button", {
                staticClass: "header-icon",
                attrs: {
                  size: "is-small",
                  "icon-left": _vm.insuranceStructureOpen
                    ? "angle-up"
                    : "angle-down",
                },
                on: { click: _vm.toggleInsuranceStructure },
              }),
            ],
            1
          ),
          _vm.insuranceStructureOpen
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  _c(
                    "div",
                    { staticClass: "subcard" },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams
                              .propertyInsuranceMonthlyRate
                          ),
                          disabled: _vm.readOnly,
                          label: "Tasa seguro de incendio",
                          placeholder: "Ingresa tasa",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          label: "Valor asegurable",
                          placeholder: "Ingresa valor",
                          prefix: "UF",
                          size: "is-small",
                          "prefix-position": "left",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "subcard" },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          label: "Tasa seguro de cesantía",
                          placeholder: "Ingresa tasa",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams
                              .unemploymentInsuranceMonthlyRate
                          ),
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          label: "Tasa subvención estatal",
                          placeholder: "Ingresa tasa",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams.subsidyRate
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "subcard" },
                    [
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Tipo de seguro de vida",
                            horizontal: "",
                          },
                        },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: {
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Selecciona un tipo",
                                expanded: "",
                              },
                              model: {
                                value:
                                  _vm.simulation.offerParams
                                    .lifeInsuranceTypeOfPremium,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.simulation.offerParams,
                                    "lifeInsuranceTypeOfPremium",
                                    $$v
                                  )
                                },
                                expression:
                                  "simulation.offerParams.lifeInsuranceTypeOfPremium",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "MULTIPLE" } }, [
                                _vm._v("Multiple"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Deudor", horizontal: "" } },
                        [
                          _c("div", { staticClass: "inner" }, [
                            _c(
                              "div",
                              { staticClass: "inner-col" },
                              [
                                _c("BInputExpanded", {
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    placeholder: "1",
                                    prefix: "desde",
                                    size: "is-small",
                                    "prefix-position": "left",
                                    value:
                                      _vm.getLifeInsuranceDebtor()?.minAge ||
                                      "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "inner-col" },
                              [
                                _c("BInputExpanded", {
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    placeholder: "5",
                                    prefix: "hasta",
                                    size: "is-small",
                                    "prefix-position": "left",
                                    value:
                                      _vm.getLifeInsuranceDebtor()?.maxAge ||
                                      "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "inner-col" },
                              [
                                _c("BInputExpanded", {
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    placeholder: "0,0076",
                                    prefix: "%",
                                    size: "is-small",
                                    "prefix-position": "left",
                                    value: _vm.formatPercentage(
                                      _vm.getLifeInsuranceDebtor()?.rate
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header header-switch" },
            [
              _c(
                "b-field",
                { attrs: { label: "¿Tiene garantía?", horizontal: "" } },
                [
                  _c("b-switch", {
                    attrs: {
                      value:
                        _vm.simulation.offerParams.segment === "INVESTMENT",
                      size: "is-small",
                      disabled: _vm.readOnly,
                    },
                    model: {
                      value: _vm.hasGuarantee,
                      callback: function ($$v) {
                        _vm.hasGuarantee = $$v
                      },
                      expression: "hasGuarantee",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.guaranteeStructureOpen || _vm.hasGuarantee
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  (
                    _vm.readOnly
                      ? _vm.simulation.offerParams.segment === "INVESTMENT"
                      : _vm.hasGuarantee
                  )
                    ? _c(
                        "div",
                        [
                          _c("BInputExpanded", {
                            attrs: {
                              disabled: _vm.readOnly,
                              label: "Ponderado inversionista",
                              placeholder: "Ingresa valor",
                              prefix: "%",
                              size: "is-small",
                              "prefix-position": "left",
                              value: _vm.formatPercentage(
                                _vm.simulation.offerParams.investmentWeight
                              ),
                            },
                          }),
                          _c("BInputExpanded", {
                            attrs: {
                              disabled: _vm.readOnly,
                              label: "Factor de propiedad",
                              placeholder: "Ingresa valor",
                              prefix: "%",
                              size: "is-small",
                              "prefix-position": "left",
                              value: _vm.formatPercentage(
                                _vm.simulation.offerParams.propertyTypeFactor
                              ),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header" },
            [
              _c("p", { staticClass: "header-title" }, [
                _vm._v("Gastos operacionales"),
              ]),
              _c("b-button", {
                staticClass: "header-icon",
                attrs: {
                  size: "is-small",
                  "icon-left": _vm.operationalExpensesStructureOpen
                    ? "angle-up"
                    : "angle-down",
                },
                on: { click: _vm.toggleOperationalExpensesStructure },
              }),
            ],
            1
          ),
          _vm.operationalExpensesStructureOpen
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  _c(
                    "b-field",
                    {
                      staticClass: "is-expanded",
                      attrs: { label: "Estudio de título", horizontal: "" },
                    },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          title: "Parámetro",
                          disabled: _vm.readOnly,
                          placeholder: "Valor",
                          prefix: "UF",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.simulation.offerParams.titleStudyExpenses,
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          title: "Financiamiento",
                          disabled: _vm.readOnly,
                          placeholder: "%",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams
                              .titleStudyExpensesPercentage
                          ),
                        },
                      }),
                      _c(
                        "div",
                        [
                          _c("div", { staticClass: "field-title" }, [
                            _c("small", [_vm._v("Convenios")]),
                          ]),
                          _c("b-switch", {
                            attrs: {
                              title: "Convenio",
                              value:
                                _vm.getAgreementOfRealState(
                                  "titleStudyExpenses"
                                ).active,
                              size: "is-small",
                              disabled: _vm.readOnly,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      staticClass: "is-expanded",
                      attrs: { label: "Tasación", horizontal: "" },
                    },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "Valor",
                          prefix: "UF",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.simulation.offerParams.appraisalExpenses,
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "%",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams
                              .appraisalExpensesPercentage
                          ),
                        },
                      }),
                      _c("b-switch", {
                        attrs: {
                          value:
                            _vm.getAgreementOfRealState("appraisalExpenses")
                              .active,
                          size: "is-small",
                          disabled: _vm.readOnly,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      staticClass: "is-expanded",
                      attrs: { label: "Escrituración", horizontal: "" },
                    },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "Valor",
                          prefix: "UF",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.simulation.offerParams.deedExpenses,
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "%",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams.deedExpensesPercentage
                          ),
                        },
                      }),
                      _c("b-switch", {
                        attrs: {
                          value:
                            _vm.getAgreementOfRealState("deedExpenses").active,
                          size: "is-small",
                          disabled: _vm.readOnly,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      staticClass: "is-expanded",
                      attrs: { label: "Notaria", horizontal: "" },
                    },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "Valor",
                          prefix: "UF",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.simulation.offerParams.notaryExpenses,
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "%",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams.notaryExpensesPercentage
                          ),
                        },
                      }),
                      _c("b-switch", {
                        attrs: {
                          value:
                            _vm.getAgreementOfRealState("notaryExpenses")
                              .active,
                          size: "is-small",
                          disabled: _vm.readOnly,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      staticClass: "is-expanded",
                      attrs: { label: "Inscripción", horizontal: "" },
                    },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "Valor",
                          prefix: "UF",
                          size: "is-small",
                          "prefix-position": "left",
                          value:
                            _vm.simulation.offerParams.realEstateExpensesRate,
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "%",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams
                              .realEstateExpensesPercentage
                          ),
                        },
                      }),
                      _c("b-switch", {
                        attrs: {
                          value: _vm.getAgreementOfRealState(
                            "realEstateExpensesRate"
                          ).active,
                          size: "is-small",
                          disabled: _vm.readOnly,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      staticClass: "is-expanded",
                      attrs: { label: "Impuesto al mutuo", horizontal: "" },
                    },
                    [
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "Valor",
                          prefix: "UF",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.simulation.offerParams.creditTaxRate,
                        },
                      }),
                      _c("BInputExpanded", {
                        attrs: {
                          disabled: _vm.readOnly,
                          placeholder: "%",
                          prefix: "%",
                          size: "is-small",
                          "prefix-position": "left",
                          value: _vm.formatPercentage(
                            _vm.simulation.offerParams.creditTaxRatePercentage
                          ),
                        },
                      }),
                      _c("b-switch", {
                        attrs: {
                          value:
                            _vm.getAgreementOfRealState("creditTaxRate").active,
                          size: "is-small",
                          disabled: _vm.readOnly,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm.eligibilityData
          ? _c("div", { staticClass: "subcard is-gray" }, [
              _c(
                "div",
                { staticClass: "subcard-header" },
                [
                  _c("p", { staticClass: "header-title" }, [
                    _vm._v("Reglas de Elegibilidad"),
                  ]),
                  _c("b-button", {
                    staticClass: "header-icon",
                    attrs: {
                      size: "is-small",
                      "icon-left": _vm.eligibilityOpen
                        ? "angle-up"
                        : "angle-down",
                    },
                    on: { click: _vm.toggleEligibility },
                  }),
                ],
                1
              ),
              _vm.eligibilityOpen
                ? _c(
                    "div",
                    { staticClass: "subcard-content fields-has-text-right" },
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Tipo", horizontal: "" } },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: {
                                value: _vm.eligibilityType.type,
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Selecciona un tipo",
                                expanded: "",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "current" } }, [
                                _vm._v("Inmediato"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Edad", horizontal: "" } },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.age?.description ?? "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa edad",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Nacionalidad", horizontal: "" } },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.nationality?.description ??
                                "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa nacionalidad",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Residencia", horizontal: "" } },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.residence?.description ??
                                "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa residencia",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "PEP", horizontal: "" } },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.publicExposedPerson
                                  ?.description ?? "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Persona Expuesta Políticamente",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Lista negra externa",
                            horizontal: "",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.blackListExternal
                                  ?.description ?? "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa lista negra externa",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Lista negra interna",
                            horizontal: "",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.blackListInternal
                                  ?.description ?? "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa lista negra interna",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Continuidad laboral",
                            horizontal: "",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.jobContinuity
                                  ?.description ?? "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Antigüedad laboral",
                            horizontal: "",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.jobSeniority
                                  ?.description ?? "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: { label: "Causas judiciales", horizontal: "" },
                        },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.lawsuit?.description ??
                                "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa causas judiciales",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Nivel de mora", horizontal: "" } },
                        [
                          _c("b-input", {
                            attrs: {
                              value:
                                _vm.eligibilityData?.defaultRate?.description ??
                                "--",
                              disabled: _vm.readOnly,
                              size: "is-small",
                              placeholder: "Ingresa nivel de mora",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "subcard" },
          [
            _c("BInputExpanded", {
              attrs: {
                label: "Valor moneda",
                disabled: _vm.readOnly,
                placeholder: "Ingresa valor",
                prefix: "CLP",
                size: "is-small",
                "prefix-position": "left",
              },
              model: {
                value: _vm.simulation.offerInputs.secondaryCurrencyFactor,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.simulation.offerInputs,
                    "secondaryCurrencyFactor",
                    $$v
                  )
                },
                expression: "simulation.offerInputs.secondaryCurrencyFactor",
              },
            }),
            _c(
              "b-field",
              { attrs: { label: "Fecha de conversión", horizontal: "" } },
              [
                _c(
                  "div",
                  { staticClass: "field has-addons" },
                  [
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        { staticClass: "button is-static" },
                        [
                          _c("b-icon", {
                            attrs: { icon: "calendar-days", size: "is-small" },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("b-input", {
                      attrs: {
                        disabled: _vm.readOnly,
                        size: "is-small",
                        placeholder: "Selecciona una fecha",
                        value: _vm.formatDate(_vm.simulation.createdAt),
                        expanded: "",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }